import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../../services/authService';

// Component for routes that should be accessible only when NOT authenticated
export const PublicRoute = ({ children, allowRegistration = true }: { children: JSX.Element, allowRegistration?: boolean }) => {
    const isAuthenticated = authService.isAuthenticated();
    const location = useLocation();

    // Liste des routes toujours accessibles, même si l'utilisateur est authentifié
    const alwaysAccessibleRoutes = ['/registration-success'];
    const isAlwaysAccessible = alwaysAccessibleRoutes.includes(location.pathname);

    // Si l'utilisateur est authentifié et que la route n'est pas dans la liste des exceptions
    console.log("step 1", allowRegistration, isAlwaysAccessible);
    if (isAuthenticated && !isAlwaysAccessible) {
        return <Navigate to="/dashboard" replace />;
    }

    // If this is the register route and direct registration is not allowed, redirect to landing page
    if (!allowRegistration && location.pathname === '/register' && !location.state?.fromPricing) {
        return <Navigate to="/" replace />;
    }

    return children;
};

// Component for routes that should be accessible only when authenticated
export const PrivateRoute = ({ children }: { children: JSX.Element }) => {
    const isAuthenticated = authService.isAuthenticated();
    const location = useLocation();
    console.log("step 1", isAuthenticated);

    // If user is not authenticated, redirect to login
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};